module.exports = __webpack_public_path__ + "img/Football_field.0d0b3a3e.png";